<!-- Bulle flottante pour ouvrir le chat -->
<div class="chat-bubble" (click)="toggleChat()">
  <i class="fas fa-comments"></i>
  <div class="pulse-ring"></div>
</div>

<!-- Fenêtre de chat -->
@if (isOpen) {
  <div class="chat-window" [class.minimized]="isMinimized">
    <!-- En-tête du chat -->
    <div class="chat-header">
      <div class="chat-header-info">
        <div class="bot-avatar">
          <i class="fas fa-robot"></i>
        </div>
        <div class="bot-info">
          <h4>Assistant Applisound</h4>
          <span class="status">En ligne</span>
        </div>
      </div>
      <div class="chat-controls">
        @if (!isMinimized) {
          <button class="control-btn" (click)="minimizeChat()" title="Réduire">
            <i class="fas fa-minus"></i>
          </button>
        }
        @if (isMinimized) {
          <button class="control-btn" (click)="maximizeChat()" title="Agrandir">
            <i class="fas fa-expand"></i>
          </button>
        }
        <button class="control-btn close-btn" (click)="closeChat()" title="Fermer">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <!-- Corps du chat -->
    @if (!isMinimized) {
      <div class="chat-body">
        <!-- Messages -->
        <div class="messages-container" #messagesContainer>
          @for (message of session?.messages; track message) {
            <div [ngClass]="getMessageClasses(message)">
              <div class="message-content">
                <div class="message-text">{{ message.text }}</div>
                <div class="message-time">{{ formatTime(message.timestamp) }}</div>
              </div>
              <!-- Options de réponse rapide -->
              @if (message.isBot && message.options && message.options.length > 0) {
                <div class="quick-replies">
                  @for (option of message.options; track option) {
                    <button
                      class="quick-reply-btn"
                      (click)="sendQuickReply(option)">
                      {{ option }}
                    </button>
                  }
                </div>
              }
            </div>
          }
          <!-- Indicateur de frappe -->
          @if (isTyping) {
            <div class="typing-indicator">
              <div class="typing-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <span class="typing-text">L'assistant écrit...</span>
            </div>
          }
        </div>
        <!-- Zone de saisie -->
        <div class="chat-input-container">
          <div class="chat-input-wrapper">
            <input
              type="text"
              class="chat-input"
              [(ngModel)]="currentMessage"
              (keypress)="onKeyPress($event)"
              placeholder="Tapez votre message..."
              #messageInput
              maxlength="500">
            <button
              class="send-btn"
              (click)="sendMessage()"
              [disabled]="!currentMessage.trim()">
              <i class="fas fa-paper-plane"></i>
            </button>
          </div>
          <!-- Suggestions rapides -->
          @if (!session?.messages || session?.messages?.length === 0) {
            <div class="quick-suggestions">
              <button class="suggestion-btn" (click)="sendQuickReply('Quels sont vos services ?')">
                <i class="fas fa-music"></i> Services
              </button>
              <button class="suggestion-btn" (click)="sendQuickReply('Quels sont vos tarifs ?')">
                <i class="fas fa-euro-sign"></i> Tarifs
              </button>
              <button class="suggestion-btn" (click)="sendQuickReply('Comment vous contacter ?')">
                <i class="fas fa-phone"></i> Contact
              </button>
            </div>
          }
        </div>
      </div>
    }
    <!-- Pied de page minifié -->
    @if (isMinimized) {
      <div class="chat-footer-mini">
        <span class="mini-status">Assistant disponible</span>
      </div>
    }
  </div>
}